define('collections/goalMonitoringReportCollection',["jQuery", "T1", "T1Collection", "models/goalMonitoringReport"], function ($, T1, T1Collection, GoalMonitoringReport) {
  T1.Models.GoalMonitoringReportCollection = T1Collection.extend({
    model: GoalMonitoringReport
  });
  return T1.Models.GoalMonitoringReportCollection;
});
